import { render, staticRenderFns } from "./taskExportHeader.vue?vue&type=template&id=bd1cc280&"
import script from "./taskExportHeader.vue?vue&type=script&lang=js&"
export * from "./taskExportHeader.vue?vue&type=script&lang=js&"
import style0 from "./taskExportHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VChipGroup,VIcon,VProgressCircular,VSnackbar,VSwitch})
